import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Aggregator } from '@liberty-financial/agp-shared';
import { filter, Subject, takeUntil } from 'rxjs';

import { ClaimsService } from '@core/authentication/claims.service';
import { aggregator } from '@env/aggregator/aggregator';
import { FeatureFlag } from '@env/environment.interface';
import { AppStatusService } from '@shared/services/service-workers';

@Component({
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  name: string = '';
  reportsFlag = FeatureFlag.Reports;
  accountType: string = 'Liberty';
  private readonly _destroying$ = new Subject<void>();

  constructor(
    public appStatus: AppStatusService,
    private router: Router,
    private claimsService: ClaimsService
  ) {}

  ngOnInit(): void {
    this.checkPendingNewVersion();

    switch (aggregator.name) {
      case Aggregator.MPM:
        this.accountType = 'Mike Pero';
        break;
      case Aggregator.NMB:
        this.accountType = 'nMB';
        break;
    }
    this.name = this.claimsService.firstName || '';
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  private checkPendingNewVersion(): void {
    this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        if (this.appStatus.hasAvailableUpdate) {
          window.location.reload();
        }
      });
  }
}
